function runLoadMethods(component, loadMethods) {
  loadMethods.forEach((method) => component[method]());
}

function createManagementPageLifecycle({
  navbar,
  loadMethods = [],
  navbarHook = "created",
}) {
  const lifecycle = {};

  if (navbar && navbarHook === "mounted") {
    lifecycle.mounted = function initializeMountedPage() {
      this.$store.dispatch("SET_NAVBAR", navbar);
      runLoadMethods(this, loadMethods);
    };
    return lifecycle;
  }

  lifecycle.mounted = function loadPageData() {
    runLoadMethods(this, loadMethods);
  };

  if (navbar) {
    lifecycle.created = function setNavbar() {
      this.$store.dispatch("SET_NAVBAR", navbar);
    };
  }

  return lifecycle;
}

module.exports = createManagementPageLifecycle;
